
<template>
    <div class="header-bar-pathfinder">
        <!-----------------  responsive menu -------------------->
        <v-navigation-drawer absolute v-model="sideNav"
                             class="hidden-sm-and-up mobile-menu elevation-bg-color"
                             width="340">
            <v-list class="pf-menu-mobile">

                    <v-list-tile v-if="isKSB !== 'PF_CHATBOT_STUDY' && isKSB !=='PF_CHATBOT' && isKSB !== 'PF_CHATBOT_PUBLIC'">
                        <v-list-tile-content>
                            <v-list-tile-title>
                                <router-link :to="'/user-account'" class="user-account underline-none">
                                    {{text("api.button.myaccount")}}
                                </router-link>
                            </v-list-tile-title>
                            <v-list-tile-sub-title></v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>

                <v-list-tile v-for="code in docCodeList"
                             :key="code"
                             @click="openDocPopup(code)"
                            >
                    <v-list-tile-content>
                        {{text("api.doc.pfi." + code)}}
                    </v-list-tile-content>
                </v-list-tile>

                <v-divider></v-divider>

                <SettingsList
                    :is-p-f-i="true"
                    @closeSideNav="closeSideNav"
                    :side-nav="sideNav"/>


                <v-btn class="new-assessment-btn-mobile"
                       block
                       v-if="isKSB === 'PF_CHATBOT_STUDY' && getAssessmentStarted"
                       @click="goToHomePage" exact>
                        {{text("api.chatbot.btn.startNewAssessment")}}
                </v-btn>

                <v-btn class="new-assessment-btn-mobile"
                       block
                       v-if="isKSB ==='PF_CHATBOT' && getAssessmentStarted"
                       @click="goToHomePage" exact>
                        {{text("api.chatbot.btn.startNewAssessment")}}
                </v-btn>

                <v-btn class="new-assessment-btn-mobile"
                       block
                       v-if="isKSB === 'PF_CHATBOT_PUBLIC' && getAssessmentStarted && getVoucherData === null"
                       @click="goToHomePage" exact>
                        {{text("api.chatbot.btn.startNewAssessment")}}
                </v-btn>

                <v-divider v-if="!isKSB"></v-divider>


                <v-list class="account-settings" v-if="!isKSB">
                    <v-list-tile to="/" @click="logOut" >
                        <v-list-tile-content class="logout-mobile">
                            <logout-icon :width="24" :height="24" class="margin-right-xs"/>
                            {{text('api.button.logout')}}
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-list>
        </v-navigation-drawer>

        <!----------------- general menu ---------------------->
        <v-toolbar  fixed class="header header-pathfinder">
            <v-spacer class="hidden-sm-and-up"></v-spacer>
            <v-toolbar-side-icon
                v-if="!sideNav"
                @click.native.stop="sideNav = !sideNav"
                class="hidden-sm-and-up mobile-menu-btn"
            ></v-toolbar-side-icon>
            <v-toolbar-side-icon
                v-if="sideNav"
                @click.native.stop="sideNav = !sideNav"
                class="hidden-sm-and-up mobile-menu-btn">
                <close-icon :svg-fill-class="'svg-secondary-color'"/>
            </v-toolbar-side-icon>
            <v-toolbar-title v-if="logo">
                <img  v-bind:src="logo" alt="smass logo"  class="logo">
            </v-toolbar-title>

            <v-toolbar-items class="pages hidden-xs-only"></v-toolbar-items>

            <v-spacer class="hidden-xs"></v-spacer>


            <v-toolbar-items class="hidden-xs-only language-dropdown-container no-margin-right">

                <a flat @click="goToHomePage" v-if="isKSB==='PF_CHATBOT_STUDY' && getAssessmentStarted" exact class="start-assesment-btn">
                    {{text("api.chatbot.btn.startNewAssessment")}}
                </a>
                <a flat @click="goToHomePage" v-if="isKSB==='PF_CHATBOT' && getAssessmentStarted" exact class="start-assesment-btn">
                    {{text("api.chatbot.btn.startNewAssessment")}}
                </a>

                <v-btn @click="goToHomePage"
                       v-if="isKSB==='PF_CHATBOT_PUBLIC' && getAssessmentStarted && getVoucherData === null"
                       outline color="primary"
                        class="new-assessment-btn-header">
                    {{text("api.chatbot.btn.startNewAssessment")}}
                </v-btn>

                <doc-dropdown :doc-code-list="docCodeList">
                        <v-btn
                            :slot="['dropdown-btn', code].join('-')"
                            flat
                            :ripple="false"
                            @click="openDocPopup(code)"
                            v-for="code in docCodeList"
                            :key="code"
                            :class="{
                            'doc-dropdown-btn': docCodeList.length !== 1,
                            'doc-btn': docCodeList.length === 1,
                            }"
                        >
                            {{text("api.doc.pfi." + code)}}
                        </v-btn>
                    </doc-dropdown>


                <SettingsMenu
                    :is-p-f-i="true"
                    :app-type="isKSB"> </SettingsMenu>


                <v-menu
                    v-model="account"
                    :nudge-width="200"
                    content-class="border-color-invisible border-radius-9"
                    class="menu-settings"
                    absolute
                    bottom
                    nudge-top="-20"
                    offset-x
                    v-if="isKSB !== 'PF_CHATBOT_STUDY' && isKSB !=='PF_CHATBOT' && isKSB !== 'PF_CHATBOT_PUBLIC'"
                >
                    <svg-button
                        slot="activator"
                    >
                        <account-icon />
                    </svg-button>
                    <v-card>
                        <v-list class="user-logged">
                            <v-list-tile >
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        <user-active-icon/>
                                        {{ getFullName }}
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title></v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                        <v-list class="account-settings">
                            <v-list-tile >
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        <router-link :to="'/user-account'" class="user-account padding-left-xs underline-none flex-align-center">
                                            <my-account-icon class="user account" :height="20" :width="20"/>
                                            {{text("api.button.myaccount")}}
                                        </router-link>
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title></v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-divider></v-divider>
                            <v-list-tile class="padding-left-xs">
                                <v-btn flat v-on:click="logOut" :ripple="false" class="btn-logout">
                                    <logout-icon class="user logout" :height="20" :width="20"/>
                                    {{text('api.button.logout')}}
                                </v-btn>
                            </v-list-tile>
                        </v-list>

                    </v-card>
                </v-menu>

            </v-toolbar-items>
        </v-toolbar>
    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';
import LoginPage from '../../../common/components/login/LoginPage';
import Vue from "vue";
import DocDropdown from "../../../common/components/shared/DocDropdown";
import ArrowDownIcon from "../../../common/components/svg/shared/arrowDownIcon";
import AccountIcon from "../../../common/components/svg/shared/accountIcon";
import MyAccountIcon from "../../../common/components/svg/shared/myAccountIcon";
import LogoutIcon from "../../../common/components/svg/shared/logoutIcon";
import SettingsIcon from "../../../common/components/svg/shared/settingsIcon";
import SvgButton from "../../../common/components/shared/SvgButton";
import LightThemeIcon from "../../../common/components/svg/shared/lightThemeIcon";
import DarkThemeIcon from "../../../common/components/svg/shared/darkThemeIcon";
import HighContrastLightIcon from "../../../common/components/svg/shared/highContrastLightIcon";
import HighContrastDarkIcon from "../../../common/components/svg/shared/highContrastDarkIcon";
import BaseSwitch from "../../../common/components/shared/BaseSwitch";
import SettingsMenu from "../../../common/components/shared/SettingsMenu";
import CloseIcon from "../../../common/components/svg/shared/closeIcon";
import SettingsList from "../../../common/components/shared/SettingsList";
import UserActiveIcon from "../../../common/components/svg/shared/userActiveIcon.vue";

export default {
        name: 'HeaderBar',
        components: {
            UserActiveIcon,
            SettingsList,
            CloseIcon,
            SettingsMenu,
            BaseSwitch,
            HighContrastDarkIcon,
            HighContrastLightIcon,
            DarkThemeIcon,
            LightThemeIcon,
            SvgButton,
            SettingsIcon,
            LogoutIcon,
            MyAccountIcon,
            AccountIcon,
            ArrowDownIcon,
            DocDropdown,
            LoginPage
        },
        data () {
            return {
                sideNav: false,
                account: false,
                currentItem: 'home',
                settings: false,
                radioButtonPlugin: Vue.RadioButton.RadioButtonSvg,
                menuIconPlugin: Vue.MenuIcon.menuIconSvg,
            }
        },

        computed: {
            ...mapGetters({
                isAdmin: 'UserStore/getIsAdmin',
                getFullName: 'UserStore/getFullName',
                logo: 'TranslationStore/getLogo',
                isKSB: 'TranslationStore/getAppTypeName',
                getAssessmentStarted: 'ChatBotStore/getAssessmentStarted',
                getVoucherData: 'TranslationStore/getVoucherData',
                getVoucherCallbackData: 'TranslationStore/getVoucherCallbackData',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getAppProperties: 'TranslationStore/getAppProperties',
                getDocCodeList: 'TranslationStore/getDocCodeList',
            }),

            mustShowFullQuestion: {
                get () {
                    return this.$store.getters['ProductListStore/getMustShowFullQuestion'];
                },
                set (newVal) {
                    this.$store.commit('ProductListStore/setMustShowFullQuestion', newVal);
                },
            },

            docCodeList() {
                return this.getDocCodeList('PFI');
            }
        },

        created() {
            window.addEventListener("resize", this.resizeWindow);
        },

        mounted() {
            let menuIcon = document.querySelector('.toolbar__side-icon.btn.btn--icon i.icon');
            menuIcon.innerHTML = this.menuIconPlugin();
        },

        destroyed() {
            window.removeEventListener("resize", this.resizeWindow);
        },

        methods: {
            logOut() {
                this.$store.dispatch("UserStore/submitLogout").then((response) => {
                    this.$router.push('/');
                });
            },

            closeSideNav() {
                // TODO Why it doesn't work
                console.log('Closing the sidenav')
                if (this.sideNav) {
                    this.sideNav = false;
                }
            },

            goToHomePage() {
                this.$router.push({name: 'PF_ChatBotPage'}).then(() => { // Go to Chatbot's home page (product list).
                    sessionStorage.removeItem("crtChatbotSection");
                    window.location.reload();
                });
            },

            goToAssessmentListPage() {
                this.$router.push('/assessment-list');
            },
            goToTestsPage() {
                this.$store.commit('TestStore/setGetTreeData', false);
                this.$store.dispatch("ProductListStore/loadProductListPageData").then(() => {
                    this.$router.push('/tests');
                });
            },

            openDocPopup(code) {
                // On responsive close the side navigation before showing the doc popup
                if (this.sideNav === true) {
                    this.sideNav = false;
                }
                this.$emit("openDocPopup", code);

            },
            resizeWindow(){
                if(this.$vuetify.breakpoint.xsOnly) {
                    this.sideNav = false;
                }
            }
        },

        watch: {
            // We need to set the menu icon everytime we close the sidenav
            sideNav(newVal, oldValue) {
                if(!newVal) {
                    this.$nextTick(() => {
                        let menuIcon = document.querySelector('.toolbar__side-icon.btn.btn--icon i.icon');
                        menuIcon.innerHTML = this.menuIconPlugin();
                    })

                }
            }
        }


    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>


    .toolbar.toolbar--fixed.header {
        background-color: $color-elevation-background;
        padding: 0 20px;
        overflow: hidden;
        box-shadow: none;
        border-bottom: 1px solid $color-block-border;

        .toolbar__content {

            .user {
                width: 18px;
                height: 18px;
                margin-right: 2px;
            }
        }

    }

    .btn-menu {
        max-width: 100%;

        .settings, .user {
           // height: 40px;
            height: 32px;
            width: 32px;
            &:first-of-type {
               // margin-left: 5px !important;

                span {
                    position: relative;
                    top: 2px;
                }
            }
        }
    }



    .menu__content {

        .list__tile__action {
            min-width: 100%;

            .input-group.input-group--selection-controls {
                min-width: 100%;
            }
        }
    }

    .settings {
        font-weight: $font-size-medium;

    }

    .btn-logout-icon:hover {
        cursor: pointer;
    }

    .user-account {
        color: $color-headings-text;
    }


    .user-logged img, .account-settings img {
        width: 22px;
    }

    .account-settings img.account{
        position: relative;
        top: 5px;
        margin-right: 18px;

    }

    .account-settings img.logout {
        margin-right: 18px;
    }

    .user-logged .list__tile__title:first-of-type {
        height:  44px !important;

        img {
            position: relative;
            top: 10px;
            width: 32px;
            margin-right: 7px;
        }
    }



    .toolbar__items .start-assesment-btn {
        margin-right: 20px;
        position: relative;
        top: 0;
        color: $color-brand-primary;
        border: 1px solid #d3d5d9;
        padding: 7px 20px;
        height: 38px;
        border-radius: 27px;
        // SMASSDEV - 1119
        font-size: $font-size-small;
        // word-spacing: $word-spacing-small;
        // line-height: $line-height-small;
        // letter-spacing: $letter-spacing-small;
        text-transform: uppercase;
    }

    @supports not (-ms-high-contrast: none) {
        @media only screen and (max-width: 960px) and (min-width: 600px) {
            .toolbar__items.language-dropdown-container {
                /*position: absolute;*/
                /*right: 15px;*/
            }

            .toolbar__items .start-assesment-btn {
                margin-right: 0;
                // SMASSDEV - 1119
                font-size: $font-size-extra-small;
                // word-spacing: $word-spacing-extra-small;
                // line-height: $line-height-extra-small;
                // letter-spacing: $letter-spacing-extra-small;
                position: relative;
                left: 15px;
            }
        }

        @media only screen and (min-width: 960px) {

            .toolbar__items .start-assesment-btn {
                margin-right: 20px;
                // SMASSDEV - 1119
                font-size: $font-size-small;
                // word-spacing: $word-spacing-small;
                // line-height: $line-height-small;
                // letter-spacing: $letter-spacing-small;
            }
        }
    }


    @media all and (-ms-high-contrast:none) {
        *::-ms-backdrop, .language-dropdown-container.toolbar__items {
            /*position: fixed !important;*/
            /*right: 0;*/
            /*top: 0;*/
        }

        *::-ms-backdrop, .language-dropdown-container.toolbar__items .start-assesment-btn {
                margin-right: 0;
                padding: 7px;
            }

        } /* IE11 */



.new-assessment-btn-header {
    font-weight: $font-weight-regular;
    text-transform: none;
    border-radius: 20px;
    padding: 0 15px;
    border-color: $color-element-outline;
}
    @media only screen and (min-width: 960px) {
        .header-pathfinder {
            padding-right: 32px !important;
            padding-left: 32px !important;
        }
    }

    @media only screen and (min-width: 600px) and (max-width:959px){
        .header-pathfinder {
            padding-right: 20px !important;
            padding-left: 20px !important;
        }
    }

    @media only screen and (max-width: 599px) {
        .header-pathfinder {
            padding-right: 16px !important;
            padding-left: 16px !important;

            .mobile-menu-btn, .toolbar__side-icon {
                position: absolute !important;
                left: 0;
                bottom: 3px;
            }
        }
    }

    .navigation-drawer {
        margin-top: 60px !important;
        box-shadow: none !important;
    }

    .legal-btn-mobile.print-legal {
        border-bottom: none !important;
    }

</style>



// WEBPACK FOOTER //
// src/pathfinder/components/shared/HeaderBar.vue